import React from 'react';
import { Container } from '@mui/material';
import BillingInvoicesPanel from '@components/billing/BillingInvoicesPanel';

const BillingInvoicesPage: React.FC = () => (
  <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
    <BillingInvoicesPanel />
  </Container>
);

export default BillingInvoicesPage;
